<template>
<div>
  
    <div class="languageMobile">
      <switch-language />
    </div>

    <v-list dense value="false"
          v-for="(menu, index) in menu"
          :name="menu.name"
          :key="'menu'+index"
          expand>

          <v-list-group  
            v-if="menu.children"
            :prepend-icon="menu.icon"
            :prepend-icon-color="menu.icon"
            :color="menu.color"
            class="menu-mobile"
            :value="false"
          >
              <template v-slot:activator>
                  <v-list-item-title class="menu-mobile">
                      {{ menu.name }}
                  </v-list-item-title>
              </template>
              <v-list-item>
                      <submenu-mobile :menu="menu"  />
              </v-list-item>
              
          </v-list-group>

          <template v-else>
            <v-list-item
                :icon="menu.icon"
                :prepend-icon-color="menu.icon"
                  :to="menu.path"
                >

                <v-list-item-icon>
                  <v-icon>{{menu.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  :prepend-icon="menu.icon"
                  :prepend-icon-color="menu.icon"
                  class="menu-mobile">
                  
                    <v-list-item-action class="menu-single">
                        {{ menu.name }}
                    </v-list-item-action>

                </v-list-item-title>

            </v-list-item>
          </template>
          <!-- 
                    <v-list-item>
                            <submenu-mobile :menu="menu"  />
                    </v-list-item> -->
          <!--       </v-list-group>   -->    
    </v-list>
  </div>

</template>

<script>

import SwitchLanguage from '@/components/SwitchLanguage.vue'
import SubmenuMobile from '@/components/menu/SubmenuMobile.vue'

export default {
  name: 'MenuBase',
  components: {
    SubmenuMobile,
    SwitchLanguage
  },
  methods: {
    triggerClick: function (route){
      this.$router.go(route);
    }
  },
  computed: {
    rutas () {
      return this.$router.options.routes;
    },
    menu () {
      return this.$store.state.menu
    }
  }
};
</script>

<style scoped lang="scss">

    .menu-mobile {
        font-family: 'Cabin', sans-serif;
        font-size: 1em !important;
    
        &-active {
            font-family: 'Cabin', sans-serif;
            color: white;
            text-decoration: none !important;

            a {
                text-decoration: none !important;
            }
        }
    }

    .languageMobile {
      position: relative;
      float: left;
      width: 100%;
    }
    .icon-submenu {
        margin-right: 5px !important;
        padding-right: 0 !important;
        width: 20px !important;
        font-size: 20px !important;
    }

    .menu-single{
      text-align: left;
    }

</style>